import type { IOfficeFileLinkHandlingInfo } from "flora-types";
import { logUsage } from "owa-analytics";
import { getEnhancedHostExtendedHost } from "owa-config/lib/enhancedHost";
import type { ExtendedHost } from "owa-config";
import type { MailboxInfo } from "owa-client-types";

export async function GetOfficeFileLinkHandlingInfo(mailboxInfo: MailboxInfo): Promise<IOfficeFileLinkHandlingInfo | undefined> {
    const extendedHost: ExtendedHost | undefined = getEnhancedHostExtendedHost();
    
    if (extendedHost) {
        const officeFileLinkHandlingInfo: IOfficeFileLinkHandlingInfo | undefined = await extendedHost.FLORA;
        
        if (officeFileLinkHandlingInfo &&
            (await officeFileLinkHandlingInfo.IsUniversalSettingSupported())) {
            logUsage("GetOfficeFileLinkHandlingInfo", mailboxInfo);
            return officeFileLinkHandlingInfo;
        }
    }
    
    return undefined;
}
